import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

async function safeJson(res) {
    try {
        return await res.json();
    } catch (_) {
        return null;
    }
}

export async function fetchLicenseStatus() {
    const res = await apiFetch(`${API_BASE}/license/status`);
    const data = await safeJson(res);

    if (!res.ok) {
        const msg = (data && data.detail) ? data.detail : "Не вдалося отримати статус ліцензії";
        throw new Error(msg);
    }

    return data;
}
